<template>
  <div class="carousel-box" :style="{width:width+'px'}">
    <div class="carousel" :style="{transform: 'translateX(-'+nowPage*100+'%)'}">
      <slot></slot>
    </div>
    <Icon @click="computedPage('back')" class='icon back log-carouser' type="ios-arrow-back" />
    <Icon @click="computedPage('forward')" class='icon forward log-carouser' type="ios-arrow-forward" />
  </div>
</template>

<script>
  export default {
    data() {
      return {
        nowPage:0,
        allpage:1,
        autoplay:false,
        width:0,
        timer:null
      }
    },
    watch:{
      autoplay:function(val){
        if(val){
          this.setAutoplay()
        }else{
          this.cancleAutoplay()
        }
      }
    },
    beforeDestroy() {
      this.cancleAutoplay()
    },
    methods:{
      cancleAutoplay(){
        window.clearInterval(this.timer)
        this.autoplay = null
      },
      setAutoplay(){
        window.clearInterval(this.timer);
        if (this.autoplay) {
            this.timer = window.setInterval(() => {
                this.computedPage('forward')
            }, 2000);
        }
      },
       computedPage(flag){
         let nowPage = this.nowPage;
         if(flag=='back'){
           if(nowPage == 0){
             nowPage=this.allpage
           }else{
             nowPage=nowPage-1
           }
         }else{
           if(nowPage == this.allpage){
             nowPage=0
           }else{
             nowPage=nowPage+1
           }
         }
         this.nowPage=nowPage;
       }
    },
    mounted(){
      this.allpage = this.$slots.default.length - 1;
      let box = this.$el.childNodes[0].childNodes[0];
      this.width=box.offsetWidth;
      window.addEventListener('resize',()=>{
        this.width=box.offsetWidth;
      })
      this.autoplay = true;
      document.getElementsByClassName('log-carouser').forEach(item=>{
        item.addEventListener('mouseout',()=>{
          this.autoplay=true
        })
        item.addEventListener('mouseover',()=>{
          this.autoplay=false
        })
      })
    }
  }
</script>
<style scoped>
  .carousel-box:hover .icon{
    display: initial;
  }
  .icon:hover{
  opacity: 1;
  }
  .back{
    left:2px;
  }
  .forward{
    right:2px;
  }
  .icon{
    /* display: none; */
    opacity: 0.5;
    cursor: pointer;
    position: absolute;
    color:#01BDED ;
    top: 50%;
    font-size:30px;
    transform: translateY(-50%);
  }
  .carousel {
    position: relative;
    top: 0;
    left: 0;
    transition: transform 800ms ease 0s;
  }

  .carousel-box {
    position: relative;
    overflow: hidden;
    padding: 0;
  }

  .carousel>div {
    flex-shrink: 0;
  }
  .carousel >div {
    padding-left: 30px;
    padding-right: 30px;
  }
  .carousel {
    padding: 0;
    display: flex;
    white-space: nowrap;
  }
</style>
